/**
 * Coerce gRPC / JS processing-date values to a finite millis number.
 * Protobuf int64 may arrive as bigint; missing fields become NaN via Number().
 */
export function toFiniteProcessingDate(value) {
  if (value == null || value === '') return null
  const n = typeof value === 'bigint' ? Number(value) : Number(value)
  return Number.isFinite(n) ? n : null
}

/** First finite millis wins (skips null / NaN). */
export function resolveProcessingDay(...candidates) {
  for (const candidate of candidates) {
    const day = toFiniteProcessingDate(candidate)
    if (day != null) return day
  }
  return null
}
